var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-recommendations-list-border" },
    [
      _c("div", { staticClass: "ai-recommendations-list-title" }, [
        _vm._v("Based on AI recommendations")
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.aiRecommendationList,
            "header-cell-style": {
              color: "#000000",
              fontFamily: "Satoshi-Medium !important",
              fontSize: "14px"
            },
            stripe: "",
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Store name", width: _vm.width },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "table-store-name-border" }, [
                      _c("div", { staticClass: "table-store-name-img" }, [
                        _c("img", {
                          attrs: { src: scope.row.mainImg },
                          on: {
                            click: function($event) {
                              return _vm.initPreview(scope, scope.row.mainImg)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-store-name" }, [
                        _c(
                          "div",
                          {
                            staticClass: "table-store-name-title",
                            on: {
                              click: function($event) {
                                return _vm.gotoReport(scope.row)
                              }
                            }
                          },
                          [_vm._v(_vm._s(scope.row.storeName))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-store-name-text" }, [
                          _vm._v(_vm._s(scope.row.address))
                        ])
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "local pedestrian traffic",
              align: "center",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatNumber(scope.row.storeVisits)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Ethnic composition",
              align: "center",
              width: "300"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", {
                      ref: "echarts" + scope.row.id,
                      staticClass: "echars"
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Store reviews", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "table-store-reviews-border" }, [
                      _c("div", { staticClass: "table-store-score" }, [
                        _vm._v(
                          _vm._s(parseFloat(scope.row.avgRating).toFixed(1))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "table-store-rate" },
                        [
                          _c("el-rate", {
                            attrs: { disabled: "", "text-color": "#F3E93D" },
                            model: {
                              value: scope.row.avgRating,
                              callback: function($$v) {
                                _vm.$set(scope.row, "avgRating", $$v)
                              },
                              expression: "scope.row.avgRating"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-store-reviews" }, [
                        _vm._v("(" + _vm._s(scope.row.reviews) + ")")
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Store's images", width: "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "table-store-images-border" }, [
                      scope.row.storeImgList &&
                      scope.row.storeImgList.length > 3
                        ? _c(
                            "div",
                            { staticClass: "table-store-images-swiper" },
                            [
                              _c(
                                "awesome-swiper",
                                {
                                  attrs: {
                                    pagination: true,
                                    turnPages: true,
                                    swiperData: _vm.storeImg,
                                    prevName: "storeImg" + scope.row.id,
                                    nextName: "storeImg" + scope.row.id
                                  }
                                },
                                _vm._l(scope.row.storeImgList, function(
                                  item,
                                  index
                                ) {
                                  return _c("swiper-slide", { key: index }, [
                                    _c("img", {
                                      staticStyle: {
                                        width: "76px",
                                        height: "58px",
                                        cursor: "pointer"
                                      },
                                      attrs: { src: item },
                                      on: {
                                        click: function($event) {
                                          return _vm.initPreview(scope, item)
                                        }
                                      }
                                    })
                                  ])
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.storeImgList &&
                      scope.row.storeImgList.length <= 3
                        ? _c(
                            "div",
                            { staticClass: "table-store-images" },
                            _vm._l(scope.row.storeImgList, function(
                              item,
                              index
                            ) {
                              return _c("img", {
                                key: index,
                                attrs: { src: item },
                                on: {
                                  click: function($event) {
                                    return _vm.initPreview(scope, item)
                                  }
                                }
                              })
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Operation", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "table-action",
                        on: {
                          click: function($event) {
                            return _vm.gotoReport(scope.row)
                          }
                        }
                      },
                      [_vm._v("Open Report")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "load-more-border",
          on: {
            click: function($event) {
              return _vm.$refs["loadMore"].init()
            }
          }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "load-more-content" }, [_vm._v("Load More")])
        ]
      ),
      _vm._v(" "),
      _c("ImgPreview", {
        ref: "imgPreviewRef",
        attrs: { "src-list": _vm.storeImgList }
      }),
      _vm._v(" "),
      _c("AiRecommendationsUpgradePlan", { ref: "loadMore" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "load-more-icon" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/vilocal/ai-load-more.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff9afd92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff9afd92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vilocal/ai-recommendations/ai-recommendations-list.vue
// module id = Q1Hj
// module chunks = 2